module.exports = __webpack_public_path__ + "img/resale.c05da90a.png";